/* =========================================================
   JaciStore · Landing Enzimas Digestivas (secciones jd-*)
   JavaScript nativo, sin librerías.
   IMPORTANTE: los botones con la clase es-popup-button-overwrite
   abren EasySell por sí solos; aquí NO se les agrega ningún clic.
   Solo se marca, dentro del formulario, la oferta del pack elegido.
   ========================================================= */
(function () {
  if (window.JDLanding) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* ---------- Galería ---------- */
  function initGallery(g) {
    if (!g || g.dataset.jdReady) return;
    g.dataset.jdReady = '1';
    var track = g.querySelector('.jd-gal__track');
    if (!track) return;
    var slides = track.querySelectorAll('.jd-gal__slide');
    var dots = g.querySelectorAll('.jd-gal__dot');
    var n = slides.length, idx = 0, target = null;
    function setActive(i) {
      idx = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var th = dots[i];
      if (th && th.classList.contains('jdp-thumb') && th.parentNode) {
        var row = th.parentNode, l = th.offsetLeft, r = l + th.offsetWidth;
        if (l < row.scrollLeft) row.scrollLeft = l - 4;
        else if (r > row.scrollLeft + row.clientWidth) row.scrollLeft = r - row.clientWidth + 4;
      }
    }
    function go(i) {
      if (!n) return;
      i = (i + n) % n; target = i;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    var prev = g.querySelector('.jd-gal__prev'), next = g.querySelector('.jd-gal__next');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.index)); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (target !== null) { if (i === target) target = null; else return; }
        if (i !== idx && i >= 0 && i < n) setActive(i);
      });
    }, { passive: true });
    window.addEventListener('resize', function () { track.scrollTo({ left: idx * track.clientWidth, behavior: 'auto' }); });
  }

  /* ---------- Bloque de compra ---------- */
  function initBuy(box) {
    if (!box || box.dataset.jdReady) return;
    box.dataset.jdReady = '1';
    var radios = box.querySelectorAll('.jd-variant input');
    var priceEl = box.querySelector('[data-jd-price]');
    var cmpEl = box.querySelector('[data-jd-compare]');
    var saveEl = box.querySelector('[data-jd-save]');
    var primary = box.querySelector('[data-jd-primary]');
    var addBtn = box.querySelector('[data-jd-add]');
    var msg = box.querySelector('[data-jd-cart-msg]');

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        box.querySelectorAll('.jd-variant').forEach(function (l) { l.classList.toggle('is-selected', l.contains(r) && r.checked); });
        var price = Number(r.dataset.price), cmp = Number(r.dataset.compare || 0), ok = r.dataset.available === 'true';
        if (priceEl) priceEl.textContent = r.dataset.priceFmt;
        var has = cmp > price;
        if (cmpEl) { cmpEl.hidden = !has; if (has) cmpEl.textContent = r.dataset.compareFmt; }
        if (saveEl) saveEl.hidden = true;
        if (primary) primary.disabled = !ok;
        if (addBtn) { addBtn.disabled = !ok; addBtn.dataset.variantId = r.value; }
        document.querySelectorAll('[data-jd-sticky-price]').forEach(function (el) { el.textContent = r.dataset.priceFmt; });
      });
    });

    if (addBtn && window.fetch) {
      addBtn.addEventListener('click', function () {
        var after = box.getAttribute('data-after') || 'cart';
        addBtn.disabled = true;
        fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(addBtn.dataset.variantId), quantity: 1 }] })
        }).then(function (res) {
          return res.json().then(function (data) { if (!res.ok) throw data; return data; });
        }).then(function () {
          if (after === 'checkout') { window.location.href = root() + 'checkout'; return; }
          if (after === 'cart') { window.location.href = root() + 'cart'; return; }
          if (msg) { msg.hidden = false; msg.classList.remove('is-error'); msg.textContent = 'Agregado al carrito.'; }
          addBtn.disabled = false;
        }).catch(function (err) {
          if (msg) { msg.hidden = false; msg.classList.add('is-error'); msg.textContent = (err && (err.description || err.message)) || 'No se pudo agregar. Intenta de nuevo.'; }
          addBtn.disabled = false;
        });
      });
    }
  }


  /* ---------- Packs de la primera pantalla ----------
     Al elegir un pack se actualizan el resumen, la barra fija y las cajas de compra marcadas
     con data-jd-pack-mirror. El pack elegido queda en JDLanding.pack(). */
  var currentPack = null;
  var packCards = [];
  function setText(sel, txt) { document.querySelectorAll(sel).forEach(function (el) { el.textContent = txt; }); }
  function applyPack(card) {
    packCards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-checked', on ? 'true' : 'false');
      c.tabIndex = on ? 0 : -1;
    });
    var d = card.dataset;
    currentPack = { qty: Number(d.qty) || 1, label: d.label || '', detail: d.detail || '', total: Number(d.total) || 0,
      totalFmt: d.totalFmt || '', compareFmt: d.compareFmt || '', save: Number(d.save) || 0, saveFmt: d.saveFmt || '',
      esTitle: d.esTitle || '', esId: d.esId || '' };
    var full = currentPack.label + (currentPack.detail ? ' · ' + currentPack.detail : '');
    var hasSave = currentPack.save > 0;
    setText('[data-jd-sum-label]', full);
    setText('[data-jd-sum-total]', currentPack.totalFmt);
    setText('[data-jd-sum-save]', hasSave ? currentPack.saveFmt : '—');
    document.querySelectorAll('[data-jd-sum-save-row]').forEach(function (el) { el.hidden = !hasSave; });
    setText('[data-jd-sum-reminder]', currentPack.label);
    setText('[data-jd-sticky-label]', full);
    setText('[data-jd-sticky-price]', currentPack.totalFmt);
    document.querySelectorAll('[data-jd-pack-mirror]').forEach(function (m) {
      var pe = m.querySelector('[data-jd-price]'), ce = m.querySelector('[data-jd-compare]'), se = m.querySelector('[data-jd-save]');
      if (pe) pe.textContent = currentPack.totalFmt;
      if (ce) { ce.hidden = !hasSave; ce.textContent = currentPack.compareFmt; }
      if (se) {
        se.hidden = !hasSave;
        var tpl = m.getAttribute('data-save-text') || 'Ahorras [amount]';
        se.textContent = tpl.replace('[amount]', currentPack.saveFmt).replace('[percent]%', '').trim();
      }
      m.querySelectorAll('[data-jd-mirror-label]').forEach(function (el) { el.textContent = full; });
    });
  }
  function initPacks(box) {
    if (!box || box.dataset.jdReady) return;
    box.dataset.jdReady = '1';
    var cards = Array.prototype.slice.call(box.querySelectorAll('.jdp-pack'));
    if (!cards.length) return;
    packCards = cards;
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { applyPack(c); });
      c.addEventListener('keydown', function (e) {
        var k = e.key, j = null;
        if (k === 'ArrowDown' || k === 'ArrowRight') j = i + 1;
        if (k === 'ArrowUp' || k === 'ArrowLeft') j = i - 1;
        if (j !== null) { e.preventDefault(); j = (j + cards.length) % cards.length; cards[j].focus(); applyPack(cards[j]); }
      });
    });
    applyPack(box.querySelector('.jdp-pack.is-selected') || cards[0]);
  }

  /* ---------- Conexión con EasySell ----------
     Los botones abren EasySell por sí solos (clase es-popup-button-overwrite); aquí no se les
     agrega ningún clic. Al pulsarlos, se espera a que el formulario muestre sus ofertas y se marca
     la oferta de EasySell del pack elegido (por su id o por su título). EasySell calcula cantidad,
     descuento y total con sus propias reglas. Si la clienta cambia de pack dentro del formulario,
     la página se actualiza para que al volver a abrirlo no quede una selección distinta. */
  function norm(t) {
    return String(t || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^A-Z0-9$]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function visible(el) { return !!(el && el.getClientRects && el.getClientRects().length); }
  /* Fuera de la página: ni dentro de una sección .jd ni conteniéndola (envoltorios del tema). */
  function outside(el) { return !!el && !el.closest('.jd') && !(el.querySelector && el.querySelector('.jd')); }
  function findById(id) {
    if (!id) return null;
    var sel = ['value', 'data-id', 'data-offer-id', 'data-offer', 'id'].map(function (a) { return '[' + a + '="' + id + '"]'; }).join(',');
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) if (outside(list[i]) && (visible(list[i]) || list[i].type === 'radio')) return list[i];
    return null;
  }
  function findByTitle(title) {
    var want = norm(title);
    if (!want) return null;
    var best = null;
    var all = document.body.querySelectorAll('div,span,p,label,li,button,strong,b,h3,h4');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!outside(el) || !visible(el)) continue;
      var txt = el.textContent || '';
      if (txt.length > 400) continue;
      if (norm(txt).indexOf(want) === -1) continue;
      if (!best || best.contains(el)) best = el;
    }
    return best;
  }
  function clickTarget(el) {
    if (el.type === 'radio') return el.closest('label') || el;
    var lab = el.closest('label');
    if (lab) return lab;
    var node = el, hops = 0;
    while (node && node !== document.body && hops < 6) {
      var radio = node.querySelector && node.querySelector('input[type="radio"]');
      if (radio) return radio.closest('label') || radio;
      if (node.matches && node.matches('[role="radio"],[role="button"],button')) return node;
      node = node.parentElement; hops++;
    }
    return el;
  }
  var esJob = null, esProgrammatic = false;
  function syncEasySell() {
    if (!document.querySelector('[data-jd-es-sync]') || !currentPack) return;
    if (!currentPack.esTitle && !currentPack.esId) return;
    if (esJob) clearInterval(esJob);
    var pack = currentPack, started = Date.now(), seenAt = 0;
    esJob = setInterval(function () {
      if (Date.now() - started > 9000) { clearInterval(esJob); esJob = null; return; }
      var el = findById(pack.esId) || findByTitle(pack.esTitle);
      if (!el) return;
      if (!seenAt) { seenAt = Date.now(); return; }
      if (Date.now() - seenAt < 250) return;
      clearInterval(esJob); esJob = null;
      esProgrammatic = true;
      try { clickTarget(el).click(); } finally { setTimeout(function () { esProgrammatic = false; }, 0); }
    }, 120);
  }
  function packFromEasySellClick(t) {
    if (!packCards.length || !outside(t)) return null;
    var node = t, hops = 0;
    while (node && node !== document.body && hops < 8 && outside(node)) {
      var txt = norm(node.textContent), hits = [];
      packCards.forEach(function (c) { var w = norm(c.dataset.esTitle); if (w && txt.indexOf(w) !== -1) hits.push(c); });
      if (hits.length === 1) return hits[0];
      if (hits.length > 1) return null;
      node = node.parentElement; hops++;
    }
    return null;
  }
  function initEasySellSync() {
    if (window.__jdEsSync) return;
    window.__jdEsSync = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.jd .es-popup-button-overwrite')) { syncEasySell(); return; }
      if (esProgrammatic || !document.querySelector('[data-jd-es-sync]')) return;
      var card = packFromEasySellClick(t);
      if (card && card !== document.querySelector('.jdp-pack.is-selected')) applyPack(card);
    }, true);
  }

  /* ---------- Barra fija ---------- */
  function initSticky(bar) {
    if (!bar || bar.dataset.jdReady) return;
    bar.dataset.jdReady = '1';
    var ticking = false;
    function inView(el) { var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight && r.width > 0; }
    function update() {
      ticking = false;
      var watched = Array.prototype.slice.call(document.querySelectorAll('[data-jd-buy-watch]'));
      if (!watched.length) return;
      var passed = watched[0].getBoundingClientRect().bottom < 0;
      var show = passed && !watched.some(inView) && getComputedStyle(bar).display !== 'none';
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      document.body.classList.toggle('jd-has-sticky', show);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  /* ---------- Enlaces internos ---------- */
  function initScroll(scope) {
    scope.querySelectorAll('a[data-jd-scroll]').forEach(function (a) {
      if (a.dataset.jdReady) return; a.dataset.jdReady = '1';
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.pageYOffset - 10;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-jd-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-jd-buy]').forEach(initBuy);
    scope.querySelectorAll('[data-jd-packs]').forEach(initPacks);
    initEasySellSync();
    document.querySelectorAll('[data-jd-sticky]').forEach(initSticky);
    initScroll(scope);
  }
  window.JDLanding = { init: init, pack: function () { return currentPack; } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();